import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable()
export class SearchModeService {
  public isAfterBulkAdd: boolean = false;

  constructor(private location: Location) {}

  isTalentMode(): boolean {
    return this.getModuleName() == 'people';
  }

  isTeamMode(): boolean {
    return this.getModuleName() == 'teams';
  }

  isTeamSearchMode(): boolean {
    return this.isTeamMode() && this.location.path().indexOf('/search/personDetails/') > -1;
  }

  isAnySearchMode(): boolean {
    const urlSegments = this.getUrlSegments();

    return this.isTalentMode() || urlSegments[3] == 'search';
  }

  private getModuleName(): string {
    const urlSegments = this.getUrlSegments();
    return urlSegments[1];
  }

  private getUrlSegments(): string[] {
    return this.location.path().split('/');
  }
}
